import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CreditPortfolio from './pages/credit-portfolio';
import Dashboard from './pages/dashboard';
import RegistryConnectors from './pages/registry-connectors';
import Article6Gateway from './pages/article-6-gateway';
import MethodologyIntelligence from './pages/methodology-intelligence';
import ProvenanceTracking from './pages/provenance-tracking';
import ClaimsBuilder from './pages/claims-builder';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Article6Gateway />} />
        <Route path="/credit-portfolio" element={<CreditPortfolio />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/registry-connectors" element={<RegistryConnectors />} />
        <Route path="/article-6-gateway" element={<Article6Gateway />} />
        <Route path="/methodology-intelligence" element={<MethodologyIntelligence />} />
        <Route path="/provenance-tracking" element={<ProvenanceTracking />} />
        <Route path="/claims-builder" element={<ClaimsBuilder />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
